var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6375_10275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0983 6.2959L44.3663 36.2039C44.6297 36.66 44.7683 37.1773 44.7683 37.7039C44.7683 38.2305 44.6297 38.7478 44.3664 39.2039C44.1031 39.6599 43.7244 40.0386 43.2683 40.3019C42.8123 40.5653 42.295 40.7039 41.7683 40.7039H7.23235C6.70574 40.7039 6.18842 40.5653 5.73237 40.3019C5.27633 40.0386 4.89762 39.6599 4.63433 39.2039C4.37103 38.7478 4.23242 38.2305 4.23242 37.7039C4.23243 37.1773 4.37104 36.66 4.63435 36.2039L21.9023 6.2959C23.0563 4.2959 25.9423 4.2959 27.0983 6.2959ZM24.5003 9.7959L8.96435 36.7039H40.0363L24.5003 9.7959ZM24.5003 29.9999C25.0308 29.9999 25.5395 30.2106 25.9146 30.5857C26.2896 30.9608 26.5003 31.4695 26.5003 31.9999C26.5003 32.5303 26.2896 33.039 25.9146 33.4141C25.5395 33.7892 25.0308 33.9999 24.5003 33.9999C23.9699 33.9999 23.4612 33.7892 23.0861 33.4141C22.7111 33.039 22.5003 32.5303 22.5003 31.9999C22.5003 31.4695 22.7111 30.9608 23.0861 30.5857C23.4612 30.2106 23.9699 29.9999 24.5003 29.9999ZM24.5003 15.9999C25.0308 15.9999 25.5395 16.2106 25.9146 16.5857C26.2896 16.9608 26.5003 17.4695 26.5003 17.9999V25.9999C26.5003 26.5303 26.2896 27.039 25.9146 27.4141C25.5395 27.7892 25.0308 27.9999 24.5003 27.9999C23.9699 27.9999 23.4612 27.7892 23.0861 27.4141C22.7111 27.039 22.5003 26.5303 22.5003 25.9999V17.9999C22.5003 17.4695 22.7111 16.9608 23.0861 16.5857C23.4612 16.2106 23.9699 15.9999 24.5003 15.9999Z",
    fill: "#EB5252"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6375_10275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.ccf66c728bb7a3118422f118172ae80e.svg";
export { ForwardRef as ReactComponent };